import { ApiEnvelope } from '@/types/apiEnvelope';

/* ----------------------- 工具函式 ----------------------- */

/**
 * 過濾物件中 undefined、null、空字串的欄位。
 * 回傳一個只包含定義值的淺拷貝。
 */
export function pickDefined<T extends Record<string, unknown>>(obj: T): Partial<T> {
  const out: Partial<T> = {};
  for (const k in obj) {
    const key = k as keyof T;
    const v = obj[key]; // v: T[keyof T]

    if (v === undefined || v === null) continue;
    // 只有在字串時才過濾空字串，避免型別不匹配
    if (typeof v === 'string' && v === '') continue;

    out[key] = v; // ✅ v 的型別是 T[keyof T]，可指派給 Partial<T>[key]
  }
  return out;
}

/**
 * 同時兼容 {status} 與 {code} 作為狀態欄位。
 * 確保回傳的 envelope 結構正確。
 */
export function ensureOk<T>(env: ApiEnvelope<T>): T {
  const status = typeof env.status === 'number' ? env.status : (env.code ?? 200);
  if (status < 200 || status >= 300) {
    throw new Error(env.message || 'Server error');
  }
  if (env.data === undefined) {
    throw new Error(env.message || '上游未回傳 data');
  }
  return env.data;
}

/**
 * 建立 FormData，僅附上已定義欄位；數字皆轉字串。
 */

export function toFormData(input: Record<string, unknown>): FormData {
  const fd = new FormData();
  for (const [key, value] of Object.entries(input)) {
    if (value === undefined || value === null || value === '') continue;

    if (value instanceof Blob) {
      fd.append(key, value);
    } else if (typeof value === 'number') {
      fd.append(key, String(value));
    } else if (typeof value === 'boolean') {
      fd.append(key, value ? 'true' : 'false');
    } else {
      fd.append(key, String(value));
    }
  }
  return fd;
}
